
const digest = '62914c085a2f39c88f5b6a7a942bb598727f9c1685f4f7ba87daa6c12ef190ec';
const classes = {"wrapper":"_wrapper_j0atd_1","toggleButton":"_toggleButton_j0atd_6","text":"_text_j0atd_12","line":"_line_j0atd_15","content":"_content_j0atd_21"};
const css = `._wrapper_j0atd_1 {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
._wrapper_j0atd_1 ._toggleButton_j0atd_6 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
}
._wrapper_j0atd_1 ._toggleButton_j0atd_6 ._text_j0atd_12 {
  text-decoration: underline;
}
._wrapper_j0atd_1 ._toggleButton_j0atd_6 ._line_j0atd_15 {
  display: flex;
  flex-grow: 1;
  height: 1px;
  background-color: rgba(163, 178, 255, 0.3);
}
._wrapper_j0atd_1 ._content_j0atd_21 {
  display: flex;
  flex-direction: column;
  gap: 12px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  